<template>
  <div class="container py-2">
    
    <div class="modal fade" id="modalError" tabindex="-1" role="dialog" aria-labelledby="modalErrorTitle" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="modalErrorTitle">Ooops...</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            An error occurred, please try again.
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
          </div>
        </div>
      </div>
    </div>

    <pno-loading :loading="loading">
    <br>
    <div class="row">
      <div class="col-lg-8" v-if="itemsInQuote > 0">
        <h1 class="h4 mt-2 mb-3">Your Quote <small class="grey">- {{ itemsInQuoteLabel }}</small></h1>
        <div class="table-responsive">
          <form class="cart">
            <table class="table">
              <thead>
                <tr>
                  <th class="small">Trailer details</th>
                  <th class="small d-none d-md-table-cell"><span class="d-md-none">Trailer details</span></th>
                  <th class="small text-center">Days</th>
                  <th class="small text-center">Period</th>
                  <th></th>
                </tr>
              </thead>
              <tbody v-for="quoteItem in quotedItems" :key="quoteItem.assetId">
                  <quote-item-row :quoteItem="quoteItem"/>
              </tbody>
            </table>
            <hr class="d-none d-lg-block">
            <p class="d-none d-lg-block">
              <small>
                <router-link class="blue" to="/trailers">← Add more trailers</router-link>
              </small>
            </p>
            <br class="d-none d-lg-block">
          </form>
        </div>
      </div>
      <div class="col-lg-8 col-xl-9" v-else>
        <h1 class="h3 mt-2 mb-3">Your Quote <small class="grey">- {{ itemsInQuoteLabel }}</small></h1>
        <hr>
        <p>Add one or several trailers to your Quote to request a price.</p>
        <router-link to="/trailers" class="btn btn-success">Search trailers</router-link>
      </div>

      <div class="col-lg-4"  v-if="itemsInQuote > 0">
        <div class="sticky">
          <div class="card mb-3">
            <div class="card-header">
              <small><i class="far fa-list-alt mr-1"></i> Quote Summary</small>
            </div>
            <div class="card-body">          
              <table class="table mb-2">
                <tbody>
                  <tr>
                    <td class="align-bottom border-0">
                      Trailers
                    </td>
                    <td class="align-bottom border-0 text-right">
                      <span class="h5">{{ itemsInQuote }}</span>
                    </td>
                  </tr>
                  <tr>
                    <td class="align-bottom">
                      Total days
                    </td>
                    <td class="align-bottom text-right">
                      <span class="h5">{{ totalDays }}</span>
                    </td>
                  </tr>
                </tbody>
              </table>
              <p class="mb-2">
                <router-link to="/booking/details" class="btn btn-lg btn-block btn-success">
                  Request booking
                </router-link>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    </pno-loading>
  </div>  
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import Vue from 'vue'
import asleep from 'await-sleep'
import QuoteItemRow from './QuoteItemRow.vue'
import Number from '@/filters/number.js'

export default {
    filters: { Number },
    components: { QuoteItemRow },
    mounted() {
      this.$store.commit('meta/title', 'Your Quote')
    },
    data: () => ({
      loading: false,
    }),
    computed: {
      ...mapGetters('quote', ['quotedItems', 'totalDays', 'itemsInQuote']),
      itemsInQuoteLabel() {
        return this.itemsInQuote == 1 ? '1 item' : this.itemsInQuote + ' items'
      },
      ...mapState('user', ['isLoggedIn']),
      ...mapState('app', ['loginUrl']),
      quotePriceGross() {
        return this.totalDays ? this.quotePrice + this.quoteDiscount : 0
      },
      quotePrice() {
        return this.totalDays ? this.totalDays*19 : 0
      },
      quoteDiscount() {
        return this.totalDays ? this.totalDays*4 : 0
      },
    },
    methods: {
      async requestQuote() {
        try {
          this.loading = true
          const customerInfo = await this.$store.dispatch('user/getCustomer')
          const requestForm = Object.assign({
            quote: this.quotedItems,
          }, customerInfo)
          await this.$store.dispatch('quote/requestQuote', requestForm)
          this.loading = false
          this.$nextTick(() => this.$router.push('/booking/confirmation'))
        }
        catch (error) {
          this.loading = false
          $('#modalError').modal('show')
          window.scrollTo({ top: 0, behavior: 'smooth' })
        }
      },
    },
}
</script>
